import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

/**
 * InvalidToken component
 *
 * @returns JSX of the component
 */
export const InvalidToken = () => {
  const { t } = useTranslation();

  return (
    <Box className='not-logged'>
      <Typography variant='body1'>
        {t('ik.it.appear.that.your.token.is.invalid')}
      </Typography>
    </Box>
  );
};
